import { gql } from '@apollo/client';
import { mutate } from '../../../../Services/Gateway/Apollo';

export const RECORD_BOOKING_EVENT = gql`
  mutation RecordBookingEvent(
    $eventName: BookingEventName!
    $slot: BookingEventSlotInput!
    $location: BookingEventLocationInput!
    $request: JSON
    $submissionId: String!
    $visitorId: String!
    $outcome: String
    $outcomeDetail: String
    $referenceId: String
    $error: BookingEventErrorInput
    $testMode: Boolean
  ) {
    recordBookingEvent(
      eventName: $eventName
      slot: $slot
      location: $location
      request: $request
      submissionId: $submissionId
      visitorId: $visitorId
      outcome: $outcome
      outcomeDetail: $outcomeDetail
      referenceId: $referenceId
      error: $error
      testMode: $testMode
    ) {
      eventStored
    }
  }
`;

const recordBookingEventMutation = (variables) =>
  mutate({ mutation: RECORD_BOOKING_EVENT, variables });

export default recordBookingEventMutation;
